export const CLASSES_IN_MENU = 'header__nav-link';
export const CLASSES_IN_CATALOG_MENU = 'header__catalog-menu-link text text--fz-17';
